export const checkoutStatusEnum = {
    CREATED: 'checkout_created',
    VALIDATED: 'checkout_validated',
    FAILED: 'checkout_failed',
}
